import styled from "@emotion/styled";
import React from "react";
import UI from "@mile-meeting/mile-ui";

export type DeviceAlarmManagerListItemProps = {
  workspaceName: string;
  channelName: string;
  onDelete: () => void;
};

const DeviceAlarmChannelListItem: React.FC<DeviceAlarmManagerListItemProps> = ({
  workspaceName,
  channelName,
  onDelete,
}) => {
  return (
    <RowContainer>
      <ProfileContainer>
        <UI.Typography type="label01" color="var(--alias-color-label-normal)">
          {workspaceName}
        </UI.Typography>
      </ProfileContainer>
      <UI.Typography
        type="label01"
        fontStyle="regular"
        color="var(--alias-color-label-alternative)"
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          marginRight: "auto",
        }}
      >
        {channelName}
      </UI.Typography>
      <BtnContainer>
        <UI.Button type="outlined" size="small" title="삭제하기" primary={false} onClick={onDelete} />
      </BtnContainer>
    </RowContainer>
  );
};
export default React.memo(DeviceAlarmChannelListItem);

const RowContainer = styled.div`
  display: flex;
  min-width: 738px;
  padding: 8px 24px;
  align-items: center;
  align-self: stretch;
  gap: 32px;

  border-bottom: 1px solid var(--alias-color-line-normal);
`;

const ProfileContainer = styled.div`
  display: flex;
  min-width: 160px;
  max-width: 200px;
  align-items: center;
  gap: 20px;
  flex: 1 0 0;
`;

const ProfileImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 40px;
  background: var(--component-color-fill-alternative);
  object-fit: contain;
`;

const BtnContainer = styled.div`
  display: flex;
  min-width: 74px;
  max-width: 160px;
  align-items: end;
  flex: 1 0 0;
`;
